<template>
  <div>
    <ion-list-header v-if="addons.length > 0">
      <ion-label>{{ $t("bookings.addAddon") }}</ion-label>
    </ion-list-header>
    <div
      class="alert-non"
      v-if="addons.length === 0"
      text
      type="warning"
      icon="mdi-calendar-remove"
    >
      No hi ha complements disponibles
    </div>
    <ion-list v-if="addons.length > 0">
      <ion-item v-for="addon of addons" :key="addon.id">
        <ion-label>
          <img v-if="addon.image" :src="addon.image" />
          <div class="name">{{ $filters.translated(addon.name_translations) }}</div>
          
          <div class="price">{{ $filters.toCurrency(addon.price) }}<span v-if="addon.daily"> / {{ $t("bookings.day") }}</span></div>
        </ion-label>
        <ion-checkbox
          slot="start"
          v-model="addon.isChecked"
          @update:modelValue="setChecked($event, addon)"
        >
        </ion-checkbox>
      </ion-item>
    </ion-list>
  </div>
</template>

<script>
import axios from "axios";
import { defineComponent } from "vue";
import { IonList, IonItem, IonLabel, IonCheckbox } from "@ionic/vue";

export default defineComponent({
  components: {
    IonList,
    IonItem,
    IonLabel,
    IonCheckbox,
  },
  props: {
    modelValue: {
      required: false,
      type: Array,
    },
  },
  data() {
    return {
      addons: [],
      selectedAddons: [],
    };
  },
  watch: {
    selectedAddons(newVal) {
      this.$emit("update:modelValue", newVal);
    },
  },
  beforeMount() {
    this.getAddons();
  },
  methods: {
    getAddons() {
      axios.get("/addons").then((resp) => {
        this.selectedAddons = [];
        this.addons = resp.data;
      });
    },
    setChecked($event, addon) {
      addon.isChecked = $event;
      this.selectedAddons = this.addons.filter((addon) => {
        return addon.isChecked;
      });
    },
  },
});
</script>

<style lang="scss" scoped>
.v-list-item__action {
  margin-right: 16px;
}
.v-avatar {
  margin: 0 14px 0 -16px;
}
.alert-non {
  background: #f7f7cf;
  color: #7a630e;
  font-weight: 500;
  padding: 20px;
  margin: 30px 16px;
  width: 95%;
  z-index: 1;
}
.color {
  width: 18px;
  height: 18px;
  display: inline-block;
  position: relative;
  top: 10px;
  margin-right: 5px;
  float: right;
  border-radius: 10px;
}
ion-label {
  display: flex !important;
    align-items: center;
  img {
    width: 22%;
  }
  .name {
    flex: 1;
    padding: 6px;
    white-space: break-spaces;
  }
  .price {
    font-weight: bold;
  }
}
</style>